module.exports = __webpack_public_path__ + "img/home_core_icon_03.458bae11.png";